export const IMAGE_URLS = [
  "/images/hero-cover.jpg",
  "/images/cruuunchify-cover.jpg",
  "/images/intelia-cover.jpg",
  "/images/home-about-cover.jpg",
  "/images/about-cover.jpg",
  "/images/about-details.jpg",
  "/images/pension-app-cover.jpg",
  "/images/controller-cover.jpg",
  "/images/dashboard-cover.jpg",
];

export const LOST_IMAGE_URL = "/images/lost.gif";

export const CASE_IMAGE_URLS = [
  "/images/cruuunchify-01.jpg",
  "/images/cruuunchify-02.jpg",
  "/images/intelia-01.jpg",
  "/images/intelia-02.jpg",
  "/images/pension-app-01.jpg",
  "/images/pension-app-02.jpg",
  "/images/controller-01.jpg",
  "/images/controller-02.jpg",
  "/images/dashboard-01.jpg",
  "/images/dashboard-02.jpg",
];

export const MODEL_URLS = [
  "assets/DualSense.glb",
  "assets/football.glb",
  "assets/XM4.glb",
];

const PADDING_TOP = 64;
const PADDING_BOTTOM = 52;

export const PROGRESS_OFFSET = PADDING_TOP + PADDING_BOTTOM;
export const FLIP_DELAY = 1400;
export const HAS_EXITED_DELAY = FLIP_DELAY + 3000;
